
$(document).ready(function(){
    
  
  // hide our element on page load
  $('#home-banner-btn').css('opacity', 1);
  $('#home-banner-btn').waypoint(function() {
    $('#home-banner-btn').addClass('pulse animated');
    $('#home-banner-btn').css('opacity', 1);
  }, { offset: '95%' });
    
  // hide our element on page load
  $('#quality-certified-nameplates-image').css('opacity', 0);
  $('#quality-certified-nameplates-image').waypoint(function() {
      $('#quality-certified-nameplates-image').addClass('fadeInUp animated');
      $('#quality-certified-nameplates-image').css('opacity', 1);
  }, { offset: '95%' });
 
  
  // hide our element on page load
  $('.feature-row__image').css('opacity', 0);
  $('.feature-row__image').waypoint(function() {
      $('.feature-row__image').addClass('bounceInLeft animated');
      $('.feature-row__image').css('opacity', 1);
  }, { offset: '70%' });
  
  // hide our element on page load
  $('#shopify-section-1542646129219').css('opacity', 0);
  $('#shopify-section-1542646129219').waypoint(function() {
      $('#shopify-section-1542646129219').addClass('fadeIn animated');
      $('#shopify-section-1542646129219').css('opacity', 1);
  }, { offset: '65%' });
  

    // hide our element on page load
  $('#shopify-section-1542630189439').css('opacity', 0);
  $('#shopify-section-1542630189439').waypoint(function() {
      $('#shopify-section-1542630189439').addClass('fadeInUp animated');
      $('#shopify-section-1542630189439').css('opacity', 1);
  }, { offset: '65%' });
  

  
 
});